export default "__VITE_ASSET__8b1a34e9__"